<template>
    <div>
        <div class="header" style="padding-top: 0">
            <div class="title">基本工资设置</div>
        </div>
        <div class="multiple">
            <Select v-model="base_from.role_id" style="width: 150px;">
                <Option v-for="(role, index) in roleList" :key="index" :value="role.id">{{role.name}}</Option>
            </Select>
            <div class="setMoney">
                <span class="inline">底薪额度</span>
                <Input v-model="base_from.number" style="width: 130px ;margin: 0 20px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <div class="setMoney">
                <Button  type="primary" @click="saveBaseSalary">保存</Button>
            </div>
        </div>
        <div class="multiple" v-for="(item, index) in baseSalaryList">
            <div style="width: 150px; text-align: center">{{item.role_name}}</div>
            <div class="setMoney">
                <span class="inline">底薪额度</span>
                <Input v-model="item.number" disabled style="width: 130px ;margin: 0 20px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <div class="setMoney">
                <Button  :data-id="item.id" @click="delSalarySet">删除</Button>
            </div>
        </div>


        <div class="header">
            <div class="title">提成设置</div>
        </div>
        <div class="multiple">
            <Select v-model="commission_form.role_id" style="width: 150px;">
                <Option v-for="(role, index) in roleList" :key="index" :value="role.id">{{role.name}}</Option>
            </Select>
            <div class="setMoney" style="width: 300px">
                <Input v-model="commission_form.begin" style="width: 120px ;margin: 0 5px;">
                    <span slot="append">元</span>
                </Input>
                <span>-</span>
                <Input v-model="commission_form.end" style="width: 120px ;margin: 0 5px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <div class="setMoney"style="width: 300px">
                <span class="inline">(含)业绩提成比例</span>
                <Input v-model="commission_form.number" style="width: 130px ;margin: 0 20px;">
                    <span slot="append">%</span>
                </Input>
            </div>
            <div class="setMoney">
                <Button  type="primary" @click="saveCommission">保存</Button>
            </div>
        </div>
        <div class="multiple" v-for="(item, index) in commissionList">
            <div v style="width: 150px; text-align: center">
                {{item.role_name}}
            </div>
            <div class="setMoney" style="width: 300px">
                <Input v-model="item.range_begin" disabled style="width: 120px ;margin: 0 5px;">
                    <span slot="append">元</span>
                </Input>
                <span>-</span>
                <Input v-model="item.range_end" disabled style="width: 120px ;margin: 0 5px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <div class="setMoney"style="width: 300px">
                <span class="inline">(含)业绩提成比例</span>
                <Input v-model="item.number" disabled style="width: 130px ;margin: 0 20px;">
                    <span slot="append">%</span>
                </Input>
            </div>
            <div class="setMoney">
                <Button :data-id="item.id" @click="delSalarySet">删除</Button>
            </div>
        </div>

        <div class="header">
            <div class="title">其它设置</div>
            <div class="save"><Button class="ivu-btn-circle" type="primary" @click="save">保存</Button></div>
        </div>
        <div class="multiple">
            <div class="child-div">数据成本</div>
            <Input v-model="other_form.data_number" style="width: 130px ;margin: 0 20px;">
                <span slot="append">元</span>
            </Input>
        </div>
        <div class="multiple">
            <div class="child-div">满勤奖</div>
            <Input v-model="other_form.work_number" style="width: 130px ;margin: 0 20px;">
                <span slot="append">元</span>
            </Input>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {getSalarySet, saveSalarySet, delSalarySet} from "../../api/task";

    export default {
        name: 'SalarySet',
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
        },
        data() {
            return {
                other_form: {
                    data_number: 0,
                    work_number: 0,
                },
                commission_form: {
                    role_id: 0,
                    begin: 0,
                    end: 0,
                    number: 0,
                },
                base_from: {
                    role_id: 0,
                    number: 0,
                },
                roleList: [],
                baseSalaryList: [],
                commissionList: [],
                checkWork: [],
            }
        },
        methods: {
            async loadData() {
                let that = this;
                let data = {
                    token: that.token
                };
                let res = await getSalarySet(that, data);
                if (res.code == 1) {
                    that.baseSalaryList = res.data.baseSalaryList
                    that.commissionList = res.data.commissionList;
                    that.checkWork = res.data.checkWork;
                    that.roleList = res.data.roleList;
                    that.other_form.data_number = res.data.dataNumber;
                    that.other_form.work_number = res.data.workNumber;
                }
            },
            delSalarySet(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                this.$Modal.confirm({
                    title: '确认删除吗？',
                    onOk: async () => {
                        let res = await delSalarySet(that, {token: that.token, id: id});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.loadData();
                        }
                    }
                })
            },
            saveBaseSalary() {
                let that = this;
                that.throttle(async function () {
                    let data = {
                        token: that.token,
                        type: 'base_salary',
                        data: that.base_from
                    };
                    let res = await saveSalarySet(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.other_form= {
                            data_number: 0,
                            work_number: 0,
                        }
                        that.loadData();
                    }
                }, 500)
            },
            saveCommission() {
                let that = this;
                that.throttle(async function () {
                    let data = {
                        token: that.token,
                        type: 'commission',
                        data: that.commission_form
                    };
                    let res = await saveSalarySet(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.commission_form = {
                            role_id: 0,
                            begin: 0,
                            end: 0,
                            number: 0,
                        }
                        that.loadData();
                    }
                }, 500)
            },
            save() {
                let that = this;
                that.throttle(async function () {
                    let data = {
                        token: that.token,
                        type: 'other',
                        data: that.other_form
                    };
                    let res = await saveSalarySet(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.loadData();
                    }
                }, 500)
            }
        }
    }
</script>

<style scoped lang="less">
    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 300px;
            height: 20px;
            margin-right: 30px;
            font-weight: bold;
        }
    }
    .setMoney{
        display: flex; align-items: center; margin-left: 20px;width: 230px
    }
    .inline{
        display: inline-block;
    }
    .header{
        display: flex;
        justify-content: start;
        padding-top: 50px;
        font-size: 17px;
        font-weight: bold;
        color: #54A1F3;
        .save{
            padding-left: 350px;
        }
    }
	/deep/ .ivu-table table {
		width: 100% !important;
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
	
	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
